<nz-header>
  <div class="app-header flex">
    <span class="header-trigger flex items-center" (click)="onToggleLeftNavigation()">
      <i class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></i>
      <img class="zdn-logo-small md:visible invisible" src="assets/images/logo-sohoadon.png" alt="Sổ hoá đơn" />
    </span>
    <div class="mr-auto"></div>
    <a class="enterprise mr-2 flex flex-row" nzTrigger="click" nz-dropdown [nzDropdownMenu]="subscriptionMenu"
      nzPlacement="bottomRight">
      <span class="font-italic">{{ enterprise?.vatId }}</span>
      <span class="hidden md:inline ml-2">{{ enterprise?.name }}</span>
    </a>
    |
    <a class="avatar-and-name ml-2" nzTrigger="click" nz-dropdown [nzDropdownMenu]="userProfileMenu"
      nzPlacement="bottomRight">
      @if (!avatarUrl || !isOnline) {
        <nz-avatar class="avatar" nzText="{{ getNamePrefix() }}">
        </nz-avatar>
      }
      @if (avatarUrl && isOnline) {
        <nz-avatar class="avatar" [nzSrc]="avatarUrl">
        </nz-avatar>
      }
      <span class="user-name">{{ fullName }}</span>
      @if (isOnline) {
        <i nz-icon nzType="down"></i>
      }
    </a>
  </div>
</nz-header>

<nz-dropdown-menu #subscriptionMenu="nzDropdownMenu">
  <ul nz-menu style="max-height: 300px; overflow-y: scroll !important" class="user-actions overflow-y-scroll">
    <li>
      <input [(ngModel)]="search" nz-input name="search" placeholder="Mã doanh nghiệp" />
    </li>
    @for (sub of subscriptions; track sub) {
      @for (enterprise of filtered(sub.enterprises); track enterprise) {
        <li nz-menu-item class="user-action-item" (click)="selectEnterprise(sub, enterprise)"
          >
          <a class="user-action flex flex-col">
            <span class="font-bold items-center flex text-lg">
              <i nz-icon nzType="bank" nzTheme="outline"></i>
            {{ enterprise?.vatId }}</span>
            <span>{{ enterprise?.name }}</span>
          </a>
        </li>
      }
    }
  </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #userProfileMenu="nzDropdownMenu">
  @if (isOnline) {
    <ul nz-menu class="user-actions">
      <!-- <li nz-menu-item class="user-action-item">
      <i nz-icon nzType="user" nzTheme="outline"></i>
      <a class="user-action" routerLink="/administrator/profile">{{
        'common.account_setting' | translate
      }}</a>
    </li> -->
    <!-- <li nz-menu-item class="user-action-item">
    <i nz-icon nzType="lock" nzTheme="outline"></i>
    <a class="user-action" routerLink="/auth/change-password">{{
      'common.change_password' | translate
    }}</a>
  </li> -->
  <li nz-menu-item (click)="payment()" class="user-action-item">
    <i nz-icon nzType="dollar" nzTheme="outline"></i>
    Thanh toán
  </li>
  <li nz-menu-item (click)="onLogout()" class="user-action-item">
    <i nz-icon nzType="logout" nzTheme="outline"></i>{{ 'common.log_out' | translate }}
  </li>
</ul>
}

</nz-dropdown-menu>